import { DocumentVersionHistory } from "@/domains/documents/components/DocumentVersionHistory";
import { VersionDialogs } from "@/domains/documents/components/organisms/VersionDialogs";
import { SignDocumentsDialog } from "@/domains/documents/components/organisms/SignDocumentsDialog";
import { TeachFranklinModal } from "@/domains/documents/components/TeachFranklinModal";
import { observer } from "mobx-react-lite";
import type { DocumentTablePresentation } from "./documentTablePresentation";
export const TableTeachDialog = observer(function TableTeachDialog(
  props: DocumentTablePresentation
) {
  const {
    teachFranklinDoc,
    teachFranklinOpen,
    setTeachFranklinOpen,
    setTeachFranklinDoc,
    handleDocumentUpdate,
  } = props;
  return (
    teachFranklinDoc && (
      <TeachFranklinModal
        open={teachFranklinOpen}
        onOpenChange={(open) => {
          setTeachFranklinOpen(open);
          if (!open) {
            setTeachFranklinDoc(null);
          }
        }}
        document={teachFranklinDoc}
        onDocumentUpdate={handleDocumentUpdate}
      />
    )
  );
});

export const TableHistoryDialog = observer(function TableHistoryDialog(
  props: DocumentTablePresentation
) {
  const { versionHistoryState, setVersionHistoryState, handlePreviewVersionDocument } = props;
  return (
    <DocumentVersionHistory
      open={versionHistoryState.open}
      onOpenChange={(open) => {
        if (!open) {
          setVersionHistoryState({ open: false, versionGroup: null, filename: "" });
        }
      }}
      versionGroup={versionHistoryState.versionGroup}
      filename={versionHistoryState.filename}
      onPreview={handlePreviewVersionDocument}
    />
  );
});

export const TableAddVersionsDialog = observer(function TableAddVersionsDialog(
  props: DocumentTablePresentation
) {
  const { onAddNewVersions, addVersions, buildingId, handlePreviewVersionDocument } = props;
  return (
    onAddNewVersions && (
      <VersionDialogs
        state={addVersions}
        onPreviewVersion={handlePreviewVersionDocument}
        buildingId={buildingId ?? addVersions.target?.building_id ?? ""}
        target={versionDialogTarget(addVersions.target)}
      />
    )
  );
});

export const TableSignDialog = observer(function TableSignDialog(props: DocumentTablePresentation) {
  const {
    signingEnabled,
    isSignDialogOpen,
    setIsSignDialogOpen,
    setSignTarget,
    store,
    buildingId,
    buildingName,
    signTarget,
    selectedDocumentsForSigning,
    onSigned,
  } = props;
  return (
    signingEnabled && (
      <SignDocumentsDialog
        open={isSignDialogOpen}
        onOpenChange={(o) => {
          setIsSignDialogOpen(o);
          if (!o) {
            setSignTarget(null);
            store.clearSelection();
          }
        }}
        buildingId={parseInt(buildingId, 10)}
        buildingName={buildingName}
        documents={signTarget ? [signTarget] : selectedDocumentsForSigning}
        onSigned={onSigned}
      />
    )
  );
});

function versionDialogTarget(target: DocumentTablePresentation["addVersions"]["target"]) {
  return target
    ? {
        id: target.id,
        filename: target.filename,
        version: target.version ?? null,
        versionGroup: target.version_group ?? null,
        ...versionDialogLocation(target),
      }
    : null;
}

function versionDialogLocation(
  target: NonNullable<DocumentTablePresentation["addVersions"]["target"]>
) {
  return {
    projectId: target.project_id ?? null,
    parentDocumentId: target.parent_document_id ?? null,
  };
}
